import { initializeApp } from "firebase/app";
import {getAuth, GoogleAuthProvider} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyC4CUxNePAtFm8NX2N9PB28psnLKBasJbc",
  authDomain: "flintt-f9792.firebaseapp.com",
  projectId: "flintt-f9792",
  storageBucket: "flintt-f9792.firebasestorage.app",
  messagingSenderId: "961495691353",
  appId: "1:961495691353:web:5148e67d04f317ee5bc148"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
